module.exports = __webpack_public_path__ + "img/titlebg.f6b8b25a.png";